import React, { useMemo } from "react";
import {
    useReactTable,
    getCoreRowModel,
    flexRender,
    createColumnHelper,
} from "@tanstack/react-table";

const Tatazippy = ({ data = [] }) => {
    const columnHelper = createColumnHelper();

    // ------------------ AUTO-CREATE COLUMNS ------------------
    const columns = useMemo(() => {
        if (!data.length) return [];

        return Object.keys(data[0]).map((key) =>
            columnHelper.accessor(row => row[key], {
                id: key,
                header: key.toUpperCase().replace(/_/g, " "),
                cell: info => info.getValue() ?? "---",
            })
        );
    }, [data]);

    // ------------------ CREATE TABLE INSTANCE ------------------
    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    return (
        <div className="overflow-auto max-h-[70vh] border rounded-lg">
            <table className="min-w-full border-collapse">
                {/* ------------------ HEADER ------------------ */}
                <thead className="bg-[#267CB8] text-white sticky top-0 z-10 shadow">
                    {table.getHeaderGroups().map((hg) => (
                        <tr key={hg.id}>
                            {hg.headers.map((header) => (
                                <th
                                    key={header.id}
                                    className="border px-4 py-3 text-left whitespace-nowrap"
                                >
                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>

                {/* ------------------ BODY ------------------ */}
                <tbody>
                    {table.getRowModel().rows.map((row) => (
                        <tr key={row.id} className="even:bg-gray-50">
                            {row.getVisibleCells().map((cell) => (
                                <td
                                    key={cell.id}
                                    className="border px-4 py-2 whitespace-nowrap"
                                >
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Tatazippy;
